/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationIntegrationShopServiceTimeSlotDto } from './applicationIntegrationShopServiceTimeSlotDto';
import { ApplicationIntegrationOrderItemDto } from './applicationIntegrationOrderItemDto';
import { ApplicationIntegrationCustomerDto } from './applicationIntegrationCustomerDto';


export interface ApplicationIntegrationOrderDto { 
    id?: number;
    deliveryDate?: string;
    deliveryPlace?: string | null;
    deliveryTime?: string | null;
    notes?: string | null;
    created?: string;
    modified?: string | null;
    status?: number;
    serviceTypeId?: number;
    numberOfCustomers?: number | null;
    shopName?: string | null;
    shopId?: number | null;
    siteId?: number | null;
    companyId?: number | null;
    customer?: ApplicationIntegrationCustomerDto;
    orderItems?: Array<ApplicationIntegrationOrderItemDto> | null;
    shopServiceTimeSlot?: ApplicationIntegrationShopServiceTimeSlotDto;
}

